/* eslint-disable @typescript-eslint/naming-convention */
import { isValidEmail, isValidName } from '../../../../Utils/validation';
import { isValidPhoneNumber } from 'libphonenumber-js';
import * as Yup from 'yup';

/** US default: national formats and display strings fail `isValidPhoneNumber(v)` without a country. */
function isCollectorPhoneValid(v: string | undefined): boolean {
  if (!v?.trim()) return false;
  if (isValidPhoneNumber(v)) return true;
  return isValidPhoneNumber(v, 'US');
}

export const collectorProfileValidationSchema = (reviewProfile: boolean) =>
  Yup.object().shape({
    profile_img: Yup.string().nullable(),
    first_name: Yup.string()
      .trim()
      .required('First name is required')
      .test('valid-name', 'Enter a valid first name', (v) => !v || isValidName(v)),
    middle_name: Yup.string()
      .trim()
      .test('valid-name', 'Enter a valid middle name', (v) => !v || isValidName(v)),
    last_name: Yup.string()
      .trim()
      .required('Last name is required')
      .test('valid-name', 'Enter a valid last name', (v) => !v || isValidName(v)),
    email: Yup.string()
      .trim()
      .required('Email is required')
      .test('valid-email', 'Enter a valid email', (v) => !!v && isValidEmail(v)),
    phone_number: Yup.string()
      .required('Phone number is required')
      .test('valid-phone', 'Enter a valid phone number', (v) => isCollectorPhoneValid(v)),
    client_tags: Yup.array().min(1, 'Select at least one client tag').required('Select at least one client tag'),
  });
